import cloneDeep from 'lodash.clonedeep';
import { put, select } from 'redux-saga/effects';

import { updateScribe } from 'js/actionCreators/scribeActions';
import { SCENE_TRANSITION_KEY_NONE, SCENE_TRANSITIONS_WITH_DIRECTION } from 'js/config/consts';
import SCENE_TRANSITION_OPTIONS, { DEFAULT_SCENE_TRANSITION_DURATION } from 'js/config/sceneTransitionsOptions';
import { SetSceneTransitionTypeAction } from 'js/actionCreators/sceneTransitionsActions';
import { SceneTransitionConfig, SceneTransitionKey } from 'js/types';

import { getScribeById } from '../selectors';

import { getActiveSceneIds } from './getActiveSceneIds';
import { isValidDirectionForType } from './isValidDirectionForType';

export function* setSceneTransitionType({ transitionType, scribeId, sceneIds }: SetSceneTransitionTypeAction) {
  const scribe = (yield select(getScribeById, scribeId)) as ReturnType<typeof getScribeById>;

  if (!scribe) return;
  const updatedScribe = cloneDeep(scribe);

  let sceneIdsToUse = getActiveSceneIds(scribe, sceneIds);

  if (!sceneIdsToUse) {
    return;
  }

  let hasUpdated = false;

  sceneIdsToUse.forEach(sceneId => {
    const scene = updatedScribe.scenes.find(scene => scene.id === sceneId);

    if (!scene) {
      return;
    }

    hasUpdated = true;

    let updateDuration =
      transitionType === SCENE_TRANSITION_KEY_NONE
        ? 0
        : scene.settings.sceneTransitionTime || DEFAULT_SCENE_TRANSITION_DURATION;
    let updateType: SceneTransitionKey = (transitionType as SceneTransitionKey) || scene.settings.sceneTransitionType;

    let updateConfig: SceneTransitionConfig | undefined;

    if (SCENE_TRANSITIONS_WITH_DIRECTION.includes(transitionType)) {
      const defaultConfig = SCENE_TRANSITION_OPTIONS.find(option => option.type === updateType)?.defaultConfig;

      const previousDirection = scene.settings.sceneTransitionConfig?.direction;

      const usePreviousDirection = isValidDirectionForType(transitionType, previousDirection);

      updateConfig = {
        ...defaultConfig,
        direction: usePreviousDirection ? previousDirection : defaultConfig?.direction
      };
    } else {
      updateConfig = SCENE_TRANSITION_OPTIONS.find(option => option.type === updateType)?.defaultConfig;
    }

    scene.settings = {
      ...scene.settings,
      sceneTransitionTime: updateDuration,
      sceneTransitionType: updateType,
      sceneTransitionConfig: updateConfig
    };
  });

  if (!hasUpdated) {
    return;
  }

  yield put(updateScribe(updatedScribe));
}
